"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.props = void 0;
var withCompInfo_1 = require("../../core/withCompInfo");
exports.props = withCompInfo_1.withCompInfo(['compData'], function (_a) {
    var compData = _a.compData;
    return {
        userId: compData.userId,
        tag: compData.tag,
        imageCount: "" + compData.imageCount,
        whichImages: compData.whichImages,
        imageSize: compData.imageSize,
        layoutOrientation: compData.layoutOrientation,
    };
});
//# sourceMappingURL=FlickrBadgeWidget.js.map